import React from 'react';
import PolicyDetails from "../../../../../../../../component/PolicyDetails";

const TripsPolicyDetails = () => {

  return (
       <PolicyDetails
           type="TRIP"
           listingPageLink="/app/trips/listing"
           addCategoryPageLink="/app/trips/new/add-vehicle-type"
       />
    )
}

export default TripsPolicyDetails;
